
import { IItem, IExternalReference, ISequence, IAuthor, ILocation } from "../ISearchResponse";
import { IQuantity, IRating, IQuoteRequest, ITravellerObject } from "libraries/service/resources/hotel/ISearchParameters";
import { ISegmentRooming } from "libraries/hotel/models/quote";
import { IPropertyCredit } from "libraries/service/resources/hotel/ISearchResponse";
import { ItemClass } from "../../service/resources/watabi-resources/watabiResource.service";
import { IConsistencyAlert } from "libraries/service/quote-alert/quote-alert.service";
import { CategoryCode } from "libraries/enums/e-category-code";

export interface IItemPostRequest {
    action: EItemAction;
    idItem: number;
    class?: ItemClass;
    language?: string;
    languagesUsed?: string;
    idVersion?: number;
    idVersionParent?: number;
    personOwner?: {
        id: string;
    };
    companyOwner?: {
        id: string;
    };
    externalReferences?: IExternalReference[];
    begin?: string;
    sequences?: ISequence[];
    travellers?: IRequestTraveller[];
    credit?: IPropertyCredit;
    childrenOrder?: {
        [key: string]: number[]
    };
    duration?: number;
    whoLastUpdated?: IAuthor;
    category?: {
        code: CategoryCode
    };
    model?: {
        TravellerPrice?: {
            idItem: number;
            idVersion: number;
        }
    };
    consistencyAlert?: IConsistencyAlert;
    beginday?: number;
    locations?: ILocation[];
    title?: string;
    text?: string;
    isPlaceholderBlock? : boolean;
}

export interface IItemMoveRequest {
    action: EItemAction.Move;
    actionDetails: {
        newChild: {
            idVersion: number,
            idItem: number
        }
    };
    idVersion: number;
    childrenOrder: {
        descriptions?: number[],
        blocks?: number[],
        sections?: number[],
        sequences?: number[],
    };
}

export interface ICriteriaItemPostRequest extends IItem {
    links: ILink[];
    search?: {
        hotel?: ISearchHotelCriterias
    };
}

export interface ISearchHotelCriterias extends IQuoteRequest {
    segment: ISegmentCriterias[];
    traveller: {
        [key: string]: ITravellerObject
    };
    quantity?: IQuantity;
    nbrecord?: number;
    language: string;
    brand?: string;
    keyword?: string[];
}

export interface ISegmentCriterias {
    property: ISegmentPropertyCriterias;
    rating?: IRating;
    rooming?: ISegmentRooming;
}

interface ISegmentPropertyCriterias {
    host: string[];
}

export interface ILink {
    idSubject: number;
    verb: 'is_criteria_for' | 'is_output_for' | 'is_version_for' | 'is_clipboard_for';
    idComplement: number;
}

export interface IRequestTravellers {
    [id: string]: IRequestTraveller;
}

export interface IRequestTraveller {
    type: string;
    id: string;
    title?: string;
    lastName?: string;
    birthDate?: string;
    firstName?: string;
}

export enum EItemAction {
    Create = 'C',
    Update = 'U',
    ChildrenCopy = 'CC',
    Replicate = 'R',
    Delete = 'D',
    Move = 'M'
}
